import { MapPin, Navigation, Phone, Mail } from "lucide-react";
import { contato, mapa, emailValido } from "@/content";
import { Reveal } from "./Reveal";

const enderecoCompleto = `${contato.endereco}, ${contato.cidade}`;
const query = encodeURIComponent(mapa.consulta);

const InfoLine = ({ icon: Icon, children, testid }) => (
  <p data-testid={testid} className="flex items-start gap-3 text-[15px] leading-7 text-slate-300 sm:text-base">
    <Icon size={18} className="mt-1 shrink-0 text-cyan-300" />
    <span>{children}</span>
  </p>
);

export const LocationMap = () => (
  <Reveal delay={0.1}>
    <div data-testid="location-map-block" className="mt-6 grid gap-6 lg:grid-cols-[1fr_1.6fr]">
      <div className="glass flex flex-col rounded-3xl p-6 sm:p-8 lg:p-10">
        <p className="text-xs font-semibold uppercase tracking-[0.25em] text-cyan-300">{mapa.titulo}</p>
        <h3 className="font-display mt-4 text-2xl font-semibold text-white">{contato.cidade}</h3>
        <div className="mt-6 space-y-3">
          <InfoLine icon={MapPin} testid="contact-address">{enderecoCompleto}</InfoLine>
          <InfoLine icon={Phone} testid="contact-phone">{contato.telefoneExibicao}</InfoLine>
          <InfoLine icon={Mail} testid="contact-email">
            {emailValido ? <a href={`mailto:${contato.email}`} className="transition-colors duration-200 hover:text-cyan-300">{contato.email}</a> : contato.email}
          </InfoLine>
        </div>
        <a href={`https://www.google.com/maps/search/?api=1&query=${query}`} target="_blank" rel="noopener noreferrer"
          data-testid="open-google-maps-btn" className="btn-ghost mt-8 self-start lg:mt-auto">
          <Navigation size={16} />
          {mapa.botao}
        </a>
      </div>
      <div className="relative min-h-[320px] overflow-hidden rounded-3xl border border-white/10 sm:min-h-[380px]">
        <iframe
          title={`Mapa: ${enderecoCompleto}`}
          data-testid="location-map-iframe"
          src={`https://www.google.com/maps?q=${mapa.coordenadas}&z=17&output=embed`}
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          className="map-dark absolute inset-0 h-full w-full border-0"
        />
        <div className="pointer-events-none absolute inset-0 rounded-3xl ring-1 ring-inset ring-cyan-300/10" />
      </div>
    </div>
  </Reveal>
);
